import React from 'react';
import { cn } from '@/utils/cn';
import { RadixTooltip, RadixTooltipContent, RadixTooltipTrigger } from '@/components/_ui/app-tooltip/app-tooltip';

interface AppTooltipProps {
  children: React.ReactNode;
  content: React.ReactNode;
  contentClassName?: string;
}

const AppTooltip = ({ children, content, contentClassName }: AppTooltipProps) => {
  return (
    <RadixTooltip>
      <RadixTooltipTrigger asChild>{children}</RadixTooltipTrigger>
      <RadixTooltipContent
        className={cn('bg-white text-[#25151E] text-[12px] font-normal p-2 rounded-lg border', contentClassName)}
      >
        {content}
      </RadixTooltipContent>
    </RadixTooltip>
  );
};

export default AppTooltip;
